import { $toggleLink, AutoLinkNode, LinkNode, TOGGLE_LINK_COMMAND } from '@lexical/link';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { FALLBACK_SAFE_EDITOR_LINK_URL, sanitizeEditorLinkUrl } from '@main/shared/utils';
import { COMMAND_PRIORITY_HIGH } from 'lexical';
import { useEffect } from 'react';

export { sanitizeSerializedEditorLinks } from '@main/shared/utils';

export function LinkSanitizerPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      mergeRegister(
        editor.registerCommand(
          TOGGLE_LINK_COMMAND,
          (payload) => {
            if (payload === null) {
              return false;
            }

            if (typeof payload === 'string') {
              const sanitizedUrl = sanitizeEditorLinkUrl(payload);
              if (!sanitizedUrl) {
                return true;
              }
              if (sanitizedUrl !== payload) {
                $toggleLink(sanitizedUrl);
                return true;
              }
              return false;
            }

            const sanitizedUrl = sanitizeEditorLinkUrl(payload.url);
            if (!sanitizedUrl) {
              return true;
            }
            if (sanitizedUrl !== payload.url) {
              $toggleLink(sanitizedUrl, {
                rel: payload.rel,
                target: payload.target,
                title: payload.title,
              });
              return true;
            }

            return false;
          },
          COMMAND_PRIORITY_HIGH,
        ),
        editor.registerNodeTransform(LinkNode, sanitizeLinkNode),
        editor.registerNodeTransform(AutoLinkNode, sanitizeLinkNode),
      ),
    [editor],
  );

  return null;
}

function sanitizeLinkNode(node: LinkNode | AutoLinkNode) {
  const url = node.getURL();
  const sanitizedUrl = sanitizeEditorLinkUrl(url) ?? FALLBACK_SAFE_EDITOR_LINK_URL;
  if (sanitizedUrl !== url) {
    node.setURL(sanitizedUrl);
  }
}
